
define("bundles/catalog-category-view", function(){});
